<template>
    <div>
        <div class="row">
            <div class="column small-9">
                <PageTitle title="Organisaties" :total="total" :loading="loading" />
            </div>
            <div class="column small-3 text-right">
                <b-button type="is-dark" tag="router-link" :to="{ name: 'OrganisationsRecord', params: {id: 'nieuw'} }">Nieuw</b-button>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <b-table
                    :data="records"
                    :striped="true"
                    :loading="loading"
                    :mobile-cards="true"

                    backend-pagination
                    :total="total"
                    :per-page="perPage"
                    @page-change="onPageChange"
                    backend-sorting
                    :default-sort-direction="sortOrder"
                    :default-sort="[sortField, sortOrder]"
                    @sort="onSort"

                    :paginated="paginated"
                    :sort-icon="'chevron-up'"
                >
                    <template>
                        <!-- <b-table-column v-slot="props" field="id" label="#" sortable>
                            #{{ props.row.id }}
                        </b-table-column> -->

                        <b-table-column v-slot="props" field="name" label="Naam" sortable>
                            <router-link :to="{ name: 'OrganisationsRecord', params: {id: props.row.id} }">
                                <strong>{{ props.row.name }}</strong>
                            </router-link>
                        </b-table-column>

                        <b-table-column v-slot="props" field="type" label="Type" sortable>
                            {{ props.row.type == 'box' ? 'Box storage' : props.row.type }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="invited" label="Uitgenodigd" width="100" class="has-text-centered" sortable>
                            <b-tag
                                :type="props.row.invited ? 'is-success' : 'is-dark'"
                            >{{ props.row.invited == 0 ? 'Nee' : 'Ja' }}
                            </b-tag>
                        </b-table-column>

                        <b-table-column v-slot="props" label="Gebruikers" width="100" class="has-text-centered">
                            {{ props.row.users_count ? props.row.users_count : '-' }}
                        </b-table-column>

                        <b-table-column v-slot="props" label="Klanten" width="100" class="has-text-centered">
                            {{ props.row.customers_count ? props.row.customers_count : '-' }}
                        </b-table-column>

                        <b-table-column v-slot="props" label="Vestigingen" width="100" class="has-text-centered">
                            {{ props.row.locations_count ? props.row.locations_count : '-' }}
                        </b-table-column>

                        <b-table-column v-slot="props" label="Connect" width="100">
                            <b-tag
                                :type="props.row.connect ? 'is-success' : 'is-dark'"
                            >{{ props.row.connect === 1 ? 'Ja' : 'Nee' }}
                            </b-tag>
                        </b-table-column>

                        <b-table-column v-slot="props" field="updated_at" label="Laatst gewijzigd" width="180" sortable>
                            {{ props.row.updated_at|humanDate }}
                        </b-table-column>

                        <b-table-column v-slot="props" numeric width="100">
                            <b-button tag="router-link" type="is-dark" size="is-small" :to="'/panel/organisaties/'+props.row.id">Bekijken</b-button>
                        </b-table-column>
                    </template>

                    <template #empty>
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p class="margin0" v-if="loading === false">Geen organisaties gevonden.</p>
                                <p class="margin0" v-else>Laden...</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import filtersMixin from '@/mixins/filterMixins'

export default {
    name: 'OrganisationsOverview',
    mixins: [filtersMixin],

    data () {
        return {
            // view: 'list',
            records: [],

            total: null,
            loading: false,
            sortField: 'updated_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 20,
            searchParams: typeof(this.$store.state.searchQueries['OrganisationsOverview']) != 'undefined' ? this.$store.state.searchQueries['OrganisationsOverview'] : null
        }
    },

    created(){
        // Check if in this session a query is saved (last success) else use default sorting.
        this.getSearchParams().then(() => {
            this.loadAsyncData()
        })
    },

    computed: {
        paginated (){
            return this.records.length < this.total
        }
    },

    methods: {
        getSearchParams(){
            return new Promise((resolve) => {
                if(!_.isNull(this.searchParams)){
                    let searchParams = this.searchParams.split('&')
                    searchParams = searchParams[1].split('.')

                    this.sortField = searchParams[0].replace('sort_by=', '')
                    this.sortOrder = searchParams[1]

                    resolve()
                } else {
                    resolve()
                }
            })
        },

        loadAsyncData() {
            let params

            if(this.searchParams){
                // Only once if searchparams are stored in Vuex.state.searchParams
                params = this.searchParams
                this.$store.dispatch('setSearchQuery', {type: 'OrganisationsOverview', query: null}) // Unset after use
            } else {
                params = [
                    `paginate=${this.perPage}`,
                    `sort_by=${this.sortField}.${this.sortOrder}`,
                    `page=${this.page}`
                ].join('&')
            }

            this.loading = true

            axios.get(`/api/organisations?${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$store.dispatch('setSearchQuery', {type: 'OrganisationsOverview', query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching organisations:', error)
                this.data = []
                this.total = null
            }).then(() => {
                this.loading = false
                this.searchParams = null
            })
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },
        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        }
    }
}
</script>
